// extracted by mini-css-extract-plugin
export default {"container":"MetadataFrame_container__SS62f","row":"MetadataFrame_row__1hqW+","text":"MetadataFrame_text__dsrSJ"};